// // src/pages/AdminAdmins.jsx
// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import { ref, onValue, set, remove } from "firebase/database";

// export default function AdminAdmins() {
//   const [email, setEmail] = useState("");
//   const [admins, setAdmins] = useState([]);

//   useEffect(() => {
//     const off = onValue(ref(db, "adminsByEmail"), (snap) => {
//       const v = snap.val() || {};
//       const list = Object.keys(v).map(k => atob(k));
//       setAdmins(list);
//     });
//     return () => off();
//   }, []);

//   async function add() {
//     if (!email.includes("@")) { alert("Enter valid email"); return; }
//     await set(ref(db, `adminsByEmail/${btoa(email.trim().toLowerCase())}`), true);
//     setEmail("");
//   }

//   async function del(e) {
//     await remove(ref(db, `adminsByEmail/${btoa(e.toLowerCase())}`));
//   }

//   return (
//     <div className="space-y-6">
//       <h1 className="text-2xl md:text-3xl font-bold">Admin — Manage Admins</h1>
//       <div className="bg-white rounded-2xl shadow p-6 space-y-4">
//         <div className="flex gap-2">
//           <input
//             className="flex-1 p-3 border rounded-xl"
//             placeholder="admin@example.com"
//             value={email}
//             onChange={(e)=>setEmail(e.target.value)}
//           />
//           <button onClick={add} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Add Admin</button>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b text-left">
//                 <th className="py-2 pr-4">Email</th>
//                 <th className="py-2 pr-4">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {admins.map(e => (
//                 <tr key={e} className="border-b hover:bg-gray-50">
//                   <td className="py-2 pr-4">{e}</td>
//                   <td className="py-2 pr-4">
//                     <button onClick={()=>del(e)} className="px-3 py-1 rounded-lg border hover:bg-gray-50">Remove</button>
//                   </td>
//                 </tr>
//               ))}
//               {admins.length===0 && <tr><td colSpan="2" className="py-4 text-gray-500">No admins yet.</td></tr>}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, onValue, set, remove } from "firebase/database";

export default function AdminAdmins() {
  const [email, setEmail] = useState("");
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    const off = onValue(ref(db, "adminsByEmail"), (snap) => {
      const v = snap.val() || {};
      setAdmins(Object.keys(v).map(k => atob(k)));
    });
    return () => off();
  }, []);

  async function add() {
    const e = email.trim().toLowerCase();
    if (!e.includes("@")) { alert("Enter valid email"); return; }
    await set(ref(db, `adminsByEmail/${btoa(e)}`), true);
    setEmail("");
  }
  async function del(e) { await remove(ref(db, `adminsByEmail/${btoa(e.toLowerCase())}`)); }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Admin — Manage Admins</h1>
      <div className="bg-white rounded-2xl shadow p-6 space-y-4">
        <div className="flex gap-2">
          <input className="flex-1 p-3 border rounded-xl" placeholder="admin@example.com" value={email} onChange={(e)=>setEmail(e.target.value)} />
          <button onClick={add} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Add</button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b text-left"><th className="py-2 pr-4">Email</th><th className="py-2 pr-4">Actions</th></tr></thead>
            <tbody>
              {admins.map(e => (
                <tr key={e} className="border-b hover:bg-gray-50">
                  <td className="py-2 pr-4">{e}</td>
                  <td className="py-2 pr-4">
                    <button onClick={()=>del(e)} className="px-3 py-1 rounded-lg border hover:bg-gray-50">Remove</button>
                  </td>
                </tr>
              ))}
              {admins.length===0 && <tr><td colSpan="2" className="py-4 text-gray-500">No admins yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
